import guest from "@/middleware/guest";

export default [
    {
        path: "somos",
        name: "somos",
        meta: { middleware: [guest] },
        component: () => import("./Somos")
    }
];
